import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getDatabase, ref, get, update } from "firebase/database";

function EditVendeurPage({ uid }) {
  const { vendeurId } = useParams();
  const navigate = useNavigate();
  const db = getDatabase();

  const [form, setForm] = useState({
    name: "",
    lastName: "",
    phone: "",
  });

  useEffect(() => {
    const loadVendeur = async () => {
      const snap = await get(
        ref(db, `distributors/${uid}/vendeurs/${vendeurId}`)
      );
      if (snap.exists()) {
        setForm(snap.val());
      }
    };
    loadVendeur();
  }, [uid, vendeurId]);

  const save = async () => {
    await update(ref(db), {
      [`distributors/${uid}/vendeurs/${vendeurId}`]: form,
      [`users/${vendeurId}`]: {
        ...form,
      },
    });
    navigate("/vendeurs");
  };

 return (
  <div style={{ maxWidth: 400, margin: "auto" }}>
    <h2 style={{ textAlign: "center" }}>✏️ Modifier ce vendeur</h2>

    {["name", "lastName", "phone"].map((field) => (
      <input
        key={field}
        placeholder={
          field === "name"
            ? "الاسم"
            : field === "lastName"
            ? "اللقب"
            : "الهاتف"
        }
        type="text"
        value={form[field] || ""}
        onChange={(e) =>
          setForm({ ...form, [field]: e.target.value })
        }
        style={{
          width: "100%",
          padding: 10,
          marginBottom: 12,
          borderRadius: 6,
          border: "1px solid #ccc",
        }}
      />
    ))}

    <button
      onClick={save}
      style={{
        width: "100%",
        padding: 12,
        background: "#16a34a",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        cursor: "pointer",
      }}
    >
      💾 Sauvegarder
    </button>
  </div>
);
}

export default EditVendeurPage;
